

import { Injectable } from '@angular/core';

@Injectable()
export class KeyShortcut {

    setShortcut(key="",targetName="") {


        var UI = document.getElementById(targetName); 
        document.addEventListener('keyup',(event)=> {
            console.log("KeyShortcut_event.keyCode", event.keyCode);
            if (event.keyCode == 79) {
                UI.style.display != 'block' ? UI.style.display = 'block' : UI.style.display = 'none';
                //console.log("KeyShortcut_event.keyCode", UI.style.display);
            }
        });

    }


    open(ObjName="") {


        var UI = document.getElementById(ObjName); 
        document.addEventListener('keyup',(event)=> {
            console.log("KeyShortcut_event.keyCode", event.keyCode);
            if (event.keyCode == 79) {
                UI.style.display != 'block' ? UI.style.display = 'block' : UI.style.display = 'none';
                //console.log("KeyShortcut_event.keyCode", UI.style.display);
            }
        });

    }

}
